// Slider.tsx
import { useKeenSlider } from 'keen-slider/react';
import { useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const ImageSlider = ({
    images,
    initialIndex = 0,
    clickable = false,
    onImageClick,
  }: {
    images: string[];
    initialIndex?: number;
    clickable?: boolean;
    onImageClick?: (img: string) => void;
  }) => {
    const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
      initial: initialIndex,
      loop: true,
    });
  
    return (
      <div className="relative">
        <div ref={sliderRef} className="keen-slider rounded-lg overflow-hidden flex">
          {images.map((img, i) => (
            <div
              key={i}
              className="keen-slider__slide flex justify-center items-center "
              onClick={() => clickable && onImageClick?.(img)}
            >
                <img
                src={img}
                alt={`Slide ${i}`}
                className="max-h-[500px] max-w-full object-contain mx-auto rounded-lg shadow-md transition-transform duration-300 ease-in-out hover:scale-105" 
                />
            </div>
          ))}
        </div>
        <button
          onClick={() => instanceRef.current?.prev()}
          className="absolute left-2 top-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 p-1 rounded-full shadow"
        >
          <ChevronLeft size={20} />
        </button>
        <button
          onClick={() => instanceRef.current?.next()}
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 p-1 rounded-full shadow"
        >
          <ChevronRight size={20} />
        </button>
      </div>
    );
  };
  